/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CodeEntry } from './codeEntry';
import { HistInfo } from './histInfo';
import { BodenbedeckungVersionId } from './bodenbedeckungVersionId';
import { AvMutation } from './avMutation';


export interface BodenbedeckungVersionDetailEntry { 
    id: BodenbedeckungVersionId;
    histInfo?: HistInfo;
    bodenbedeckungArt?: BodenbedeckungVersionDetailEntry.BodenbedeckungArtEnum;
    sortIndex?: number;
    codeBodenbedeckungArt?: CodeEntry;
    flaecheQuadratmeter: number;
    bodenbedeckungArtZusatz?: string;
    mutationsNummer?: AvMutation;
    editActions?: Array<BodenbedeckungVersionDetailEntry.EditActionsEnum>;
    modificationCounter: number;
}
export namespace BodenbedeckungVersionDetailEntry {
    export type BodenbedeckungArtEnum = 'GEBAEUDE' | 'BEFESTIGT_STRASSE_WEG' | 'BEFESTIGT_TROTTOIR' | 'BEFESTIGT_VERKEHRSINSEL' | 'BEFESTIGT_BAHN' | 'BEFESTIGT_FLUGPLATZ' | 'BEFESTIGT_WASSERBECKEN' | 'BEFESTIGT_UEBRIGE_BEFESTIGTE' | 'HUMUSIERT_ACKER_WIESE_WEIDE' | 'HUMUSIERT_INTENSIVKULTUR_REBEN' | 'HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR' | 'HUMUSIERT_GARTENANLAGE' | 'HUMUSIERT_HOCH_FLACHMOOR' | 'HUMUSIERT_UEBRIGE_HUMUSIERTE' | 'GEWAESSER_STEHENDES' | 'GEWAESSER_FLIESSENDES' | 'GEWAESSER_SCHILFGUERTEL' | 'BESTOCKT_GESCHLOSSENER_WALD' | 'BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT' | 'BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN' | 'BESTOCKT_UEBRIGE_BESTOCKTE' | 'VEGETATIONSLOS_FELS' | 'VEGETATIONSLOS_GLETSCHER_FIRN' | 'VEGETATIONSLOS_GEROELL_SAND' | 'VEGETATIONSLOS_ABBAU_DEPONIE' | 'VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE' | 'GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER' | 'STRASSE_WEG_TROTTOIR_RAV' | 'BAHNEN_STRASSEN_WEGE_BISHER' | 'ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER' | 'WEIDEN_BISHER' | 'REBEN_BISHER' | 'GEWAESSER_BISHER' | 'WYTWEIDE_UEBRIGE_BESTOCKTE' | 'WALD_BISHER' | 'WEIDWALD_BISHER' | 'UNKULTIVIERTES_GEBIET_BISHER' | 'UNBESTIMMT' | 'RUNDUNGSDIFFERENZ';
    export const BodenbedeckungArtEnum = {
        GEBAEUDE: 'GEBAEUDE' as BodenbedeckungArtEnum,
        BEFESTIGT_STRASSE_WEG: 'BEFESTIGT_STRASSE_WEG' as BodenbedeckungArtEnum,
        BEFESTIGT_TROTTOIR: 'BEFESTIGT_TROTTOIR' as BodenbedeckungArtEnum,
        BEFESTIGT_VERKEHRSINSEL: 'BEFESTIGT_VERKEHRSINSEL' as BodenbedeckungArtEnum,
        BEFESTIGT_BAHN: 'BEFESTIGT_BAHN' as BodenbedeckungArtEnum,
        BEFESTIGT_FLUGPLATZ: 'BEFESTIGT_FLUGPLATZ' as BodenbedeckungArtEnum,
        BEFESTIGT_WASSERBECKEN: 'BEFESTIGT_WASSERBECKEN' as BodenbedeckungArtEnum,
        BEFESTIGT_UEBRIGE_BEFESTIGTE: 'BEFESTIGT_UEBRIGE_BEFESTIGTE' as BodenbedeckungArtEnum,
        HUMUSIERT_ACKER_WIESE_WEIDE: 'HUMUSIERT_ACKER_WIESE_WEIDE' as BodenbedeckungArtEnum,
        HUMUSIERT_INTENSIVKULTUR_REBEN: 'HUMUSIERT_INTENSIVKULTUR_REBEN' as BodenbedeckungArtEnum,
        HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR: 'HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR' as BodenbedeckungArtEnum,
        HUMUSIERT_GARTENANLAGE: 'HUMUSIERT_GARTENANLAGE' as BodenbedeckungArtEnum,
        HUMUSIERT_HOCH_FLACHMOOR: 'HUMUSIERT_HOCH_FLACHMOOR' as BodenbedeckungArtEnum,
        HUMUSIERT_UEBRIGE_HUMUSIERTE: 'HUMUSIERT_UEBRIGE_HUMUSIERTE' as BodenbedeckungArtEnum,
        GEWAESSER_STEHENDES: 'GEWAESSER_STEHENDES' as BodenbedeckungArtEnum,
        GEWAESSER_FLIESSENDES: 'GEWAESSER_FLIESSENDES' as BodenbedeckungArtEnum,
        GEWAESSER_SCHILFGUERTEL: 'GEWAESSER_SCHILFGUERTEL' as BodenbedeckungArtEnum,
        BESTOCKT_GESCHLOSSENER_WALD: 'BESTOCKT_GESCHLOSSENER_WALD' as BodenbedeckungArtEnum,
        BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT: 'BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT' as BodenbedeckungArtEnum,
        BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN: 'BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN' as BodenbedeckungArtEnum,
        BESTOCKT_UEBRIGE_BESTOCKTE: 'BESTOCKT_UEBRIGE_BESTOCKTE' as BodenbedeckungArtEnum,
        VEGETATIONSLOS_FELS: 'VEGETATIONSLOS_FELS' as BodenbedeckungArtEnum,
        VEGETATIONSLOS_GLETSCHER_FIRN: 'VEGETATIONSLOS_GLETSCHER_FIRN' as BodenbedeckungArtEnum,
        VEGETATIONSLOS_GEROELL_SAND: 'VEGETATIONSLOS_GEROELL_SAND' as BodenbedeckungArtEnum,
        VEGETATIONSLOS_ABBAU_DEPONIE: 'VEGETATIONSLOS_ABBAU_DEPONIE' as BodenbedeckungArtEnum,
        VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE: 'VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE' as BodenbedeckungArtEnum,
        GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER: 'GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER' as BodenbedeckungArtEnum,
        STRASSE_WEG_TROTTOIR_RAV: 'STRASSE_WEG_TROTTOIR_RAV' as BodenbedeckungArtEnum,
        BAHNEN_STRASSEN_WEGE_BISHER: 'BAHNEN_STRASSEN_WEGE_BISHER' as BodenbedeckungArtEnum,
        ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER: 'ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER' as BodenbedeckungArtEnum,
        WEIDEN_BISHER: 'WEIDEN_BISHER' as BodenbedeckungArtEnum,
        REBEN_BISHER: 'REBEN_BISHER' as BodenbedeckungArtEnum,
        GEWAESSER_BISHER: 'GEWAESSER_BISHER' as BodenbedeckungArtEnum,
        WYTWEIDE_UEBRIGE_BESTOCKTE: 'WYTWEIDE_UEBRIGE_BESTOCKTE' as BodenbedeckungArtEnum,
        WALD_BISHER: 'WALD_BISHER' as BodenbedeckungArtEnum,
        WEIDWALD_BISHER: 'WEIDWALD_BISHER' as BodenbedeckungArtEnum,
        UNKULTIVIERTES_GEBIET_BISHER: 'UNKULTIVIERTES_GEBIET_BISHER' as BodenbedeckungArtEnum,
        UNBESTIMMT: 'UNBESTIMMT' as BodenbedeckungArtEnum,
        RUNDUNGSDIFFERENZ: 'RUNDUNGSDIFFERENZ' as BodenbedeckungArtEnum
    };
    export type EditActionsEnum = 'AENDERN' | 'KORRIGIEREN' | 'STREICHEN' | 'STORNIEREN';
    export const EditActionsEnum = {
        AENDERN: 'AENDERN' as EditActionsEnum,
        KORRIGIEREN: 'KORRIGIEREN' as EditActionsEnum,
        STREICHEN: 'STREICHEN' as EditActionsEnum,
        STORNIEREN: 'STORNIEREN' as EditActionsEnum
    };
}


